import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';

import { BaseEmptyState, illustrationStyle } from './base-empty-state.tsx';
import messages from './messages.ts';
import { NoVerifiedAgentsIllustration } from './no-verified.illustration.tsx';

export type NoVerifiedAgentsEmptyStateProps = {
	onSeeAllAgentsClick?: (
		analyticsEvent: Parameters<NonNullable<React.ComponentProps<typeof Button>['onClick']>>[1],
	) => void;
	singleColumn?: boolean;
};

export const NoVerifiedAgentsEmptyState = ({
	onSeeAllAgentsClick,
	singleColumn,
}: NoVerifiedAgentsEmptyStateProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<BaseEmptyState
			singleColumn={singleColumn}
			illustration={
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
				<NoVerifiedAgentsIllustration style={illustrationStyle} />
			}
			heading={formatMessage(messages.noVerifiedAgentsHeader)}
			description={formatMessage(messages.noVerifiedAgents)}
			cta={
				onSeeAllAgentsClick && (
					<Button
						appearance="primary"
						onClick={(_, analyticsEvent) => onSeeAllAgentsClick(analyticsEvent)}
					>
						{formatMessage(messages.seeAllAgentsButton)}
					</Button>
				)
			}
		/>
	);
};
